import React from 'react';
import { FOOTER_LINKS, SUPPORT_EMAIL } from '../data/config';
export function Footer() {
  return <footer className="bg-navyDeep px-4 py-5 text-center md:px-12" data-id="element-55" data-mp="3gfiugihumbe4">
      <p className="font-heading text-[11px] font-extrabold uppercase text-white" data-id="element-56" data-mp="32nul2myzi10u">
        © 2026 Bright Digital Hub — All rights reserved.
      </p>
      <p className="mx-auto mt-1.5 max-w-[640px] text-[12px] leading-[1.4] text-white/70" data-id="element-57" data-mp="36q92r3qx2uqj">
        The Complete Speech Therapy Activities Bundle™ provides educational activities and practical support resources
        for speech-language professionals. It does not replace professional training, individualized assessment,
        clinical judgment, or applicable legal and professional requirements.
      </p>
      <nav aria-label="Legal" className="mt-1.5 text-[12px] text-white" data-id="element-58" data-mp="3qbvojhhb2r9e">
        {FOOTER_LINKS.map((l, i) => <React.Fragment key={l.label} data-id="element-59" data-mp="2a19tpmiidoxa" data-mpi={i}>
            {i > 0 && <span className="mx-1.5" aria-hidden data-id="element-60" data-mp="2eyjrbpg1x6w7">•</span>}
            <a href={l.href} className="transition-colors duration-150 hover:text-gold" data-id="element-61" data-mp="2evx98vvjb8zq">
              {l.label}
            </a>
          </React.Fragment>)}
      </nav>
      <p className="mt-1 text-[12px] text-white" data-id="element-62" data-mp="3gc0jbpn0e4a9">
        Support:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline hover:text-gold" data-id="element-63" data-mp="3v8rgrtd4h5x8">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}